import { render } from "./culture.vue?vue&type=template&id=3f74ddd2&scoped=true"
import script from "./culture.vue?vue&type=script&lang=js"
export * from "./culture.vue?vue&type=script&lang=js"

import "./culture.vue?vue&type=style&index=0&id=3f74ddd2&scoped=true&lang=css"

import exportComponent from "D:\\Web\\hkjt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f74ddd2"]])

export default __exports__